module.exports = __webpack_public_path__ + "static/img/lock_title.8b10fb8a.png";